import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useWorkingModel } from "@/hooks/useWorkingModel";
import { Empty, Button } from "@/components/ui";
import { LayoutGrid } from "lucide-react";

export function PageHeader({ eyebrow, title, subtitle, right }) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && <p className="abl-eyebrow mb-1">{eyebrow}</p>}
        <h1 className="text-2xl font-black tracking-tight sm:text-3xl">{title}</h1>
        {subtitle && <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

// Wrapper for the engineering deliverable screens that require a chosen plan.
export function RequireModel({ children }) {
  const { lang } = useAuth();
  const [wm] = useWorkingModel();
  const isAr = lang === "ar";
  if (!wm?.model) {
    return (
      <div className="mx-auto max-w-2xl px-4 py-16">
        <Empty
          icon={LayoutGrid}
          title={isAr ? "لا يوجد مخطط محدد بعد" : "No active plan yet"}
          hint={
            isAr
              ? "ابدأ من الاستوديو أو المعالج لتوليد مخطط، أو اختر أحد المخططات العشرة - ثم ستعمل كل الشاشات الهندسية على المخطط المختار."
              : "Generate a plan from the Studio or Wizard, or pick one of the 10 variants - then every engineering screen will work on the chosen plan."
          }
          action={
            <Link to="/studio">
              <Button variant="primary">{isAr ? "افتح الاستوديو" : "Open Studio"}</Button>
            </Link>
          }
        />
      </div>
    );
  }
  return children({ wm, isAr });
}
